const SAFE_PRODUCT_ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/;

export function getLegacyProductRedirect(search: string): string {
    const sourceParams = new URLSearchParams(search);
    const candidate = sourceParams.get("product_id") || sourceParams.get("contract_product_id") || "";

    if(!SAFE_PRODUCT_ID_PATTERN.test(candidate)){
        return "/tabs/products";
    }

    const nextParams = new URLSearchParams({ product_id: candidate });
    return `/tabs/products?${nextParams.toString()}`;
}
